import React, { FC, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { get } from 'lodash';

import { SideNavProps, TopNavProps, BannerProps, Progress } from '@trip-ux/components';
import { POLICY_ROUTES } from '@trip-ux/constants';
import { ReduxStore } from '@trip-ux/redux-store';
import { lazyWithChunkRetry } from '@trip-ux/common';

import './booking.scss';
import NavBar from '../shared/NavBar';

const Confirmation = lazyWithChunkRetry(() => import('./confirmation/Confirmation'));
const PlanSelection = lazyWithChunkRetry(() => import('./plan-selection/PlanSelection'));
const SummaryPayment = lazyWithChunkRetry(() => import('./summary-review/SummaryPayment'));
const TravellerDetails = lazyWithChunkRetry(() => import('./traveller-details/TravellerDetails'));
const QuoteStepOne = lazyWithChunkRetry(() => import('./quote/QuoteStepOne'));

export interface BookingProps {
  basename?: string;
  sideNav?: SideNavProps;
  topNav?: TopNavProps;
  banner?: BannerProps;
  isAdmin?: boolean;
}

export const Booking: FC<BookingProps> = ({ basename }) => {
  const { config } = useSelector((store: ReduxStore) => ({
    config: store.config
  }));

  const isAdmin = get(config, 'isAdmin');

  return (
    <NavBar>
      <Suspense fallback={<Progress backdrop />}>
        <Routes>
          <Route path={POLICY_ROUTES.TRAVELLER_DETAILS} element={<TravellerDetails />} />
          <Route path={POLICY_ROUTES.SUMMARY} element={<SummaryPayment />} />
          <Route path={POLICY_ROUTES.CONFIRMATION} element={<Confirmation />} />
          <Route
            path={isAdmin ? POLICY_ROUTES.PLAN_SELECTION_ADMIN : POLICY_ROUTES.PLAN_SELECTION}
            element={<PlanSelection />}
          />
          <Route path={POLICY_ROUTES.QUOTE} element={<QuoteStepOne />} />
        </Routes>
      </Suspense>
    </NavBar>
  );
};

Booking.displayName = 'Booking';
export default Booking;
